import { render, staticRenderFns } from "./follow-wares.vue?vue&type=template&id=36bc0207&scoped=true"
import script from "./follow-wares.vue?vue&type=script&lang=js"
export * from "./follow-wares.vue?vue&type=script&lang=js"
import style0 from "./follow-wares.vue?vue&type=style&index=0&id=36bc0207&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc0207",
  null
  
)

export default component.exports